import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { PatientService } from '@services/patient.service';
import { ClinicReportDetailsViewModel, ReportsService } from '@services/reports.service';

@Component({
  selector: 'app-category-sales-details',
  templateUrl: './category-sales-details.component.html',
  styleUrls: ['./category-sales-details.component.less'],
})
export class CategorySalesDetailsComponent {
  loading: boolean = false;
  @Input() categoryDetails: ClinicReportDetailsViewModel[] = [];

  constructor(private router: Router, private reportsService: ReportsService, private patientService: PatientService) {}

  navigateToPatientInvoice(patientId: number, invoiceId: number) {
    this.patientService.getPatientById(patientId).subscribe((patient: any) => {
      this.patientService.patientPanelPatient = patient;
      this.router.navigate([
        '/reports',
        {
          outlets: {
            'action-panel': [
              'patient',
              patientId + '_patientprofiletab',
              'patienttabs',
              'patientaccounttab',
              'invoice',
              invoiceId,
            ],
          },
        },
      ]);
    });
  }
}
